module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./SimplePump.js"));
	}, "SimplePump");
}